import { CalendarDate, today, getLocalTimeZone, type DateValue } from '@internationalized/date';

export function todayDate(): CalendarDate {
  return today(getLocalTimeZone());
}

export function tomorrow(): CalendarDate {
  return todayDate().add({ days: 1 });
}

export function addNights(date: DateValue, nights: number): CalendarDate {
  const d = date as CalendarDate;
  return d.add({ days: nights });
}

export function toISODate(date: DateValue): string {
  const d = date as CalendarDate;
  const y = d.year.toString().padStart(4, '0');
  const m = d.month.toString().padStart(2, '0');
  const day = d.day.toString().padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function nightsBetween(start: DateValue, end: DateValue): number {
  const s = start as CalendarDate;
  const e = end as CalendarDate;
  const msPerDay = 24 * 60 * 60 * 1000;
  const startMs = new Date(s.year, s.month - 1, s.day).getTime();
  const endMs = new Date(e.year, e.month - 1, e.day).getTime();
  return Math.round((endMs - startMs) / msPerDay);
}

export function formatDate(date: DateValue, locale: string): string {
  const d = date as CalendarDate;
  const jsDate = new Date(d.year, d.month - 1, d.day);
  return new Intl.DateTimeFormat(locale, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(jsDate);
}
